import * as React from 'react';
import { History, Location } from 'history';
import { Col, FormControl, FormGroup, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import Dropzone from 'react-dropzone';

import { PagedList, User } from '../gs-core/common';

import './DocListView.css';
import { DocThumbnail } from './DocThumbnail/DocThumbnail';
import { SubjectPanel, SubjectTypeSelector } from '../Subject';
import { Doc, DocStatus, FilterParamsFull, DEFAULT_PAGE_SIZE, Subject, DocStatuses } from '../common/models';
import { SubjectSelection } from '../services';
import { Pagination } from '../Pagination/Pagination';
import { DocStatusSelect } from './DocStatusSelect';

interface DocListViewProps {
  currentUser: User;
  selection?: SubjectSelection;
  docs?: PagedList<Doc>;
  filters: FilterParamsFull;
  canUpload: boolean;
  doUpload: (files: File[]) => void;
  history: History;
  location: Location;
  loading: boolean;
  onChangePage: (page: number) => void;
  onChangeStatus: (statuses?: DocStatus[]) => void;
  onSearch: (text: string) => void;
  onSelectSubject: (subject: Subject) => void;
}

interface DocListViewState {
  searchText: string;
}

export class DocListView extends React.Component<DocListViewProps, DocListViewState> {
  constructor(props: DocListViewProps) {
    super(props);
    this.state = { searchText: this.props.filters.text || '' };
  }

  onSearchChange = (event: React.FormEvent<FormControl & HTMLInputElement>) => {
    this.setState({ searchText: event.currentTarget.value });
  };

  onSearchEnter = (event: React.KeyboardEvent<FormControl & HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.props.onSearch(this.state.searchText || '');
    }
  };

  chooseFiles = (event: React.ChangeEvent<HTMLInputElement>) => {
    const fileList = event.target.files;
    if (fileList && fileList.length) {
      this.props.doUpload(Array.from(fileList)); // Convert FileList to array
    }
  };

  dropFiles = (files: File[]) => {
    if (files && files.length) {
      this.props.doUpload(files);
    }
  };

  componentWillReceiveProps(nextProps: DocListViewProps) {
    if (nextProps.filters.text !== this.props.filters.text) {
      this.setState({ searchText: nextProps.filters.text || '' });
    }
  }

  render() {
    const { currentUser, selection, docs, filters, canUpload, loading, onChangePage, onChangeStatus, onSelectSubject } =
      this.props;
    const { pageSize = DEFAULT_PAGE_SIZE, createdBy, owningUnits, statuses } = filters;
    const owningUnit = owningUnits && owningUnits.length ? owningUnits[0] : undefined;
    const showSubjectType = selection && selection.allSubjects.length > 1;
    const viewingDeleted = statuses && statuses.includes(DocStatuses.DELETED);

    return (
      <div className="DocListView">
        <Row className="top-controls">
          <form>
            <div className="col-md-12 col-lg-5">
              {selection && showSubjectType && (
                <SubjectTypeSelector subjectSelection={selection} onChange={onSelectSubject} className="pull-right" />
              )}
              {selection && <SubjectPanel subject={selection.selectedSubject} />}
              {owningUnit && <h2>{owningUnit.displayName || owningUnit.name} docs</h2>}
              {createdBy && createdBy.id === currentUser.id && <h2>My uploads</h2>}
            </div>
            <FormGroup className="col-md-4 col-lg-3">
              <DocStatusSelect selectedStatuses={statuses} onChange={onChangeStatus} />
            </FormGroup>
            <FormGroup className="col-md-8 col-lg-4">
              <FormControl
                type="text"
                value={this.state.searchText}
                placeholder="Search title, details &amp; content"
                onChange={this.onSearchChange}
                onKeyDown={this.onSearchEnter}
              />
            </FormGroup>
          </form>
        </Row>
        <Row>
          <Col xs={12}>
            <Dropzone
              acceptClassName="drag-over-dropzone"
              className="dropzone"
              // eslint-disable-next-line react/jsx-boolean-value
              disableClick={true}
              disabled={!canUpload}
              inputProps={{ 'aria-label': 'Upload files' }}
              // eslint-disable-next-line react/jsx-boolean-value
              multiple={true}
              onDrop={this.dropFiles}
            >
              {docs && docs.records.length ? (
                <div>
                  <Row className="display-flex">
                    {docs.records.map((doc) => (
                      <Col key={doc.id} sm={6} md={4} lg={2}>
                        <DocThumbnail doc={doc} link={doc.getRoute()} showSubject={!selection} />
                      </Col>
                    ))}
                  </Row>
                  <Row>
                    <Col xs={12}>
                      <Pagination
                        page={docs.page}
                        pageSize={pageSize}
                        total={docs.total}
                        disabled={loading}
                        onChangePage={onChangePage}
                      />
                    </Col>
                  </Row>
                </div>
              ) : (
                <div className="text-center">
                  {docs &&
                    ((!viewingDeleted && canUpload && (
                      <h2 className="text-muted">Drag and drop a file here to upload</h2>
                    )) ||
                      (!docs.records.length && !canUpload && <h2 className="text-muted">No results found</h2>) ||
                      (viewingDeleted && !docs.records.length && <h2 className="text-muted">No results found</h2>))}
                </div>
              )}
            </Dropzone>
          </Col>
        </Row>
        {!viewingDeleted && canUpload ? (
          <OverlayTrigger overlay={<Tooltip id="Upload">Upload</Tooltip>} placement="top">
            <label className="btn btn-primary upload">
              <i className="fa fa-cloud-upload" />
              <input
                type="file"
                onChange={this.chooseFiles}
                style={{ display: 'none' }}
                // eslint-disable-next-line react/jsx-boolean-value
                multiple={true}
              />
            </label>
          </OverlayTrigger>
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/DocListView/DocListView.tsx